import { render, staticRenderFns } from "./ProduccionTiempoReal.vue?vue&type=template&id=044b4878&"
import script from "./ProduccionTiempoReal.vue?vue&type=script&lang=js&"
export * from "./ProduccionTiempoReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports